// // import React, { useState, useEffect, useCallback } from "react";
// // import { 
// //   X, 
// //   Search, 
// //   FileText, 
// //   FileSpreadsheet, 
// //   Loader2, 
// //   Upload,
// //   CheckCircle2 
// // } from "lucide-react";
// // import api from "../../../chat/api"; 
// // import toast from "react-hot-toast";

// // const SelectProjectModal = ({ isOpen, onClose, folderId, onImport }) => {
// //   const [loading, setLoading] = useState(false);
// //   const [filesData, setFilesData] = useState({ documents: [], folder_name: "" });
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [selectedFileId, setSelectedFileId] = useState(null);

// //   // --- API Logic ---
// //   const fetchFiles = useCallback(async () => {
// //     if (!folderId) return;
    
// //     setLoading(true);
// //     try {
// //       const response = await api.get(`api/v1/rfp/folders/${folderId}/files/`);

// //       if (response.status === 200) {
// //         const data = response.data;
        
// //         const mappedFiles = {
// //           msg: data.msg || "Documents retrieved successfully",
// //           documents: data.documents?.map((doc) => ({
// //               id: doc.id,
// //               name: doc.name || "Untitled",
// //               uploaded_at: doc.uploaded_at,
// //               size: doc.size || "0 KB",
// //               type: doc.type || "-", // Used for Tag
// //               url: doc.url,
// //               key: doc.key,
// //               file_type: doc.file_type, // Used for Icon
// //               time_ago: doc.time_ago,
// //               status: doc.status || "ready",
// //             })) || [],
// //           folder_name: data.folder_name,
// //         };

// //         setFilesData(mappedFiles);
// //       } else {
// //         setFilesData({ documents: [], folder_name: "N/A" });
// //       }
// //     } catch (error) {
// //       console.error("Error fetching files:", error);
// //       toast.error("Failed to load project files");
// //       setFilesData({ documents: [], folder_name: "N/A" });
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [folderId]);

// //   useEffect(() => {
// //     if (isOpen) {
// //       fetchFiles();
// //       setSelectedFileId(null); 
// //       setSearchQuery("");
// //     }
// //   }, [isOpen, fetchFiles]);

// //   // --- Filtering ---
// //   const filteredFiles = filesData.documents.filter((doc) =>
// //     doc.name.toLowerCase().includes(searchQuery.toLowerCase())
// //   );

// //   // --- Helper: File Icons ---
// //   const getFileIcon = (fileName, type) => {
// //     const t = (fileName?.split('.').pop() || type || "").toLowerCase();
    
// //     if (t.includes("xls") || t.includes("csv") || t.includes("sheet")) {
// //       return <FileSpreadsheet className="w-5 h-5 text-green-600 fill-green-50" />;
// //     }
// //     if (t.includes("pdf")) {
// //       return <FileText className="w-5 h-5 text-red-600 fill-red-50" />;
// //     }
// //     if (t.includes("doc")) {
// //       return <FileText className="w-5 h-5 text-blue-600 fill-blue-50" />;
// //     }
// //     return <FileText className="w-5 h-5 text-gray-400" />;
// //   };

// //   // --- Helper: Tags ---
// //   const getTagStyle = (tag) => {
// //     const t = (tag || "").toLowerCase();
// //     if (t === "urgent") return "bg-purple-100 text-purple-700 border-purple-300";
// //     if (t === "budget") return "bg-[#ecfccb] text-[#4d7c0f] border-[#d9f99d]";
// //     if (t === "questionnaire") return "bg-red-100 text-red-700 border-red-200";
// //     if (t === "t&c") return "bg-yellow-100 text-yellow-700 border-yellow-200";
// //     if (t === "sales") return "bg-pink-100 text-pink-700 border-pink-200";
// //     if (t === "rfp") return "bg-green-100 text-green-700 border-green-200";
// //     return "bg-gray-100 text-gray-600 border-gray-200";
// //   };

// //   if (!isOpen) return null;

// //   return (
// //     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[1px] animate-in fade-in duration-200">
      
// //       <div 
// //         className="bg-white rounded-xl shadow-2xl w-full font-outfit max-w-[650px] flex flex-col animate-in zoom-in-95 duration-200 border border-gray-100"
// //         style={{ height: '600px', maxHeight: '70vh' }}
// //       >
        
// //         {/* --- Header --- */}
// //         <div className="px-8 pt-6 pb-2">
// //           <div className="flex justify-between items-start mb-1">
// //             <div>
// //               <h2 className="text-[18px] font-semibold text-[#18101C] leading-tight">
// //                 {filesData.folder_name || "Project Files"}
// //               </h2>
// //               <p className="text-[14px] text-[#52525B] font-normal mt-1">
// //                 Select a file ({selectedFileId ? "1" : "0"}/1 Selected)
// //               </p>
// //             </div>

// //             <div className="relative w-[240px]">
// //               <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
// //               <input
// //                 type="text"
// //                 placeholder="Search documents"
// //                 value={searchQuery}
// //                 onChange={(e) => setSearchQuery(e.target.value)}
// //                 /* FIX APPLIED HERE: Added !text-[14px] !leading-5 to force fixed size */
// //                 className="w-full pl-9 pr-3 py-2 bg-white border border-gray-200 rounded-md !text-[14px] !leading-5 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors"
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* --- Column Headers --- */}
// //         <div className="px-8 mt-2">
// //           <div className="border-b border-[#0000001A] pb-3 flex">
// //             <span className="text-[14px] text-[#00000080] font-medium w-[75%]">Document Name</span>
// //             <span className="text-[14px] text-[#00000080] font-medium w-[25%]">Tags</span>
// //           </div>
// //         </div>

// //         {/* --- File List --- */}
// //         <div className="flex-1 overflow-y-auto px-4 custom-scrollbar">
// //           {loading ? (
// //             <div className="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
// //               <Loader2 className="w-8 h-8 animate-spin text-[#C95EBE]" />
// //               <span className="text-sm">Loading files...</span>
// //             </div>
// //           ) : filteredFiles.length > 0 ? (
// //             <div className="py-2 space-y-2">
// //               {filteredFiles.map((file) => {
// //                 const isSelected = selectedFileId === file.id;
// //                 return (
// //                   <div
// //                     key={file.id}
// //                     onClick={() => setSelectedFileId(isSelected ? null : file.id)}
// //                     className={`relative flex items-center px-2 py-2 rounded-lg cursor-pointer transition-all border ${
// //                       isSelected
// //                         ? "bg-[#fdf2f8] border-[#f0abfc] shadow-sm"
// //                         : "bg-white border-transparent hover:bg-gray-50"
// //                     }`}
// //                   >
// //                     {/* Document Name & Icon */}
// //                     <div className="w-[75%] pl-3 flex items-center gap-3 pr-4">
// //                       <div className="shrink-0">
// //                         {getFileIcon(file.name, file.file_type)}
// //                       </div>
// //                       <span className="text-[14px] text-gray-700 font-medium truncate">
// //                         {file.name}
// //                       </span>
// //                     </div>

// //                     {/* Tag & Checkmark */}
// //                     <div className="w-[25%] flex items-center justify-between">
// //                       <span 
// //                         className={`p-4 py-1 rounded-full text-[12px] font-medium border ${getTagStyle(file.type)}`}
// //                       >
// //                         {file.type || "RFP"}
// //                       </span>
                      
// //                       {/* Only show Green Check when selected */}
// //                       {isSelected && (
// //                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
// //                         <path d="M8.6 11.8L6.45 9.65C6.26667 9.46667 6.03333 9.375 5.75 9.375C5.46667 9.375 5.23333 9.46667 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.1 14.1 8.33333 14.2 8.6 14.2C8.86667 14.2 9.1 14.1 9.3 13.9L14.95 8.25C15.1333 8.06667 15.225 7.83333 15.225 7.55C15.225 7.26667 15.1333 7.03333 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" fill="#34C759"/>
// //                       </svg>
// //                       )}
// //                     </div>
// //                   </div>
// //                 );
// //               })}
// //             </div>
// //           ) : (
// //             <div className="h-full flex items-center justify-center text-gray-400 text-sm">
// //               No documents found
// //             </div>
// //           )}
// //         </div>

// //         {/* --- Footer --- */}
// //         <div className="py-5 flex justify-center">
// //           <button
// //             disabled={!selectedFileId}
// //             onClick={() => {
// //                 const file = filesData.documents.find(f => f.id === selectedFileId);
// //                 onImport(file);
// //                 onClose();
// //             }}
// //             className={`flex items-center gap-2 px-6 py-2 rounded-lg text-[14px] font-medium transition-all shadow-sm ${
// //               selectedFileId
// //                 ? "bg-[#C95EBE]  text-white border border-gray-200" 
// //                 : "bg-gray-100 text-gray-400 cursor-not-allowed"
// //             }`}
// //           >
// //             <Upload size={16} />
// //             Import and Extract
// //           </button>
// //         </div>

// //       </div>
      
// //       {/* Click outside to close */}
// //       <div className="absolute inset-0 -z-10" onClick={onClose}></div>
// //     </div>
// //   );
// // };

// // export default SelectProjectModal;
// import React, { useState, useEffect, useCallback } from "react";
// import { 
//   X, 
//   Search, 
//   FileText, 
//   FileSpreadsheet, 
//   Loader2, 
//   Upload,
//   CheckCircle2 
// } from "lucide-react";
// import api from "../../../chat/api"; 
// import toast from "react-hot-toast";

// const SelectProjectModal = ({ isOpen, onClose, folderId, onImport }) => {
//   const [loading, setLoading] = useState(false);
//   const [filesData, setFilesData] = useState({ documents: [], folder_name: "" });
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedFileId, setSelectedFileId] = useState(null);
  
//   // New state for handling the import button process
//   // 'idle' | 'loading' | 'success'
//   const [importStatus, setImportStatus] = useState('idle');

//   // --- API Logic for Fetching Files ---
//   const fetchFiles = useCallback(async () => {
//     if (!folderId) return;
    
//     setLoading(true);
//     try {
//       const response = await api.get(`api/v1/rfp/folders/${folderId}/files/`);

//       if (response.status === 200) {
//         const data = response.data;
        
//         const mappedFiles = {
//           msg: data.msg || "Documents retrieved successfully",
//           documents: data.documents?.map((doc) => ({
//               id: doc.id,
//               name: doc.name || "Untitled",
//               uploaded_at: doc.uploaded_at,
//               size: doc.size || "0 KB",
//               type: doc.type || "-", // Used for Tag
//               url: doc.url,
//               key: doc.key,
//               file_type: doc.file_type, // Used for Icon
//               time_ago: doc.time_ago,
//               status: doc.status || "ready",
//             })) || [],
//           folder_name: data.folder_name,
//         };

//         setFilesData(mappedFiles);
//       } else {
//         setFilesData({ documents: [], folder_name: "N/A" });
//       }
//     } catch (error) {
//       console.error("Error fetching files:", error);
//       toast.error("Failed to load project files");
//       setFilesData({ documents: [], folder_name: "N/A" });
//     } finally {
//       setLoading(false);
//     }
//   }, [folderId]);

//   useEffect(() => {
//     if (isOpen) {
//       fetchFiles();
//       setSelectedFileId(null); 
//       setSearchQuery("");
//       setImportStatus('idle'); // Reset button state on open
//     }
//   }, [isOpen, fetchFiles]);

//   // --- Handle Import & Extract Button Click ---
//   const handleImportClick = async () => {
//     if (!selectedFileId) return;

//     // 1. Show Loading "Processing..."
//     setImportStatus('loading');

//     try {
//         const payload = {
//             folder_id: folderId,
//             doc_id: selectedFileId
//         };

//         // 2. Make API Call
//         const response = await api.post("/api/v1/rfp/import-questionnaire/", payload);

//         if (response.status === 200 || response.status === 201) {
//             // 3. Show Success "Extracted"
//             setImportStatus('success');
//             toast.success("Import started successfully!");

//             // 4. Wait 2 seconds, then Close & Refresh
//             setTimeout(() => {
//                 onImport(); // Trigger parent refresh
//                 onClose();  // Close modal
//                 setImportStatus('idle'); // Reset for next time
//             }, 2000);
//         } else {
//             throw new Error("API responded with non-success status");
//         }

//     } catch (error) {
//         console.error("Import failed:", error);
//         toast.error("Failed to import questionnaire.");
//         setImportStatus('idle'); // Revert button on error
//     }
//   };

//   // --- Filtering ---
//   const filteredFiles = filesData.documents.filter((doc) =>
//     doc.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // --- Helper: File Icons ---
//   const getFileIcon = (fileName, type) => {
//     const t = (fileName?.split('.').pop() || type || "").toLowerCase();
    
//     if (t.includes("xls") || t.includes("csv") || t.includes("sheet")) {
//       return <FileSpreadsheet className="w-5 h-5 text-green-600 fill-green-50" />;
//     }
//     if (t.includes("pdf")) {
//       return <FileText className="w-5 h-5 text-red-600 fill-red-50" />;
//     }
//     if (t.includes("doc")) {
//       return <FileText className="w-5 h-5 text-blue-600 fill-blue-50" />;
//     }
//     return <FileText className="w-5 h-5 text-gray-400" />;
//   };

//   // --- Helper: Tags ---
//   const getTagStyle = (tag) => {
//     const t = (tag || "").toLowerCase();
//     if (t === "urgent") return "bg-purple-100 text-purple-700 border-purple-300";
//     if (t === "budget") return "bg-[#ecfccb] text-[#4d7c0f] border-[#d9f99d]";
//     if (t === "questionnaire") return "bg-red-100 text-red-700 border-red-200";
//     if (t === "t&c") return "bg-yellow-100 text-yellow-700 border-yellow-200";
//     if (t === "sales") return "bg-pink-100 text-pink-700 border-pink-200";
//     if (t === "rfp") return "bg-green-100 text-green-700 border-green-200";
//     return "bg-gray-100 text-gray-600 border-gray-200";
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[1px] animate-in fade-in duration-200">
      
//       <div 
//         className="bg-white rounded-xl shadow-2xl w-full font-outfit max-w-[650px] flex flex-col animate-in zoom-in-95 duration-200 border border-gray-100"
//         style={{ height: '600px', maxHeight: '70vh' }}
//       >
        
//         {/* --- Header --- */}
//         <div className="px-8 pt-6 pb-2">
//           <div className="flex justify-between items-start mb-1">
//             <div>
//               <h2 className="text-[18px] font-semibold text-[#18101C] leading-tight">
//                 {filesData.folder_name || "Project Files"}
//               </h2>
//               <p className="text-[14px] text-[#52525B] font-normal mt-1">
//                 Select a file ({selectedFileId ? "1" : "0"}/1 Selected)
//               </p>
//             </div>

//             <div className="relative w-[240px]">
//               <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search documents"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full pl-9 pr-3 py-2 bg-white border border-gray-200 rounded-md !text-[14px] !leading-5 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors"
//               />
//             </div>
//           </div>
//         </div>

//         {/* --- Column Headers --- */}
//         <div className="px-8 mt-2">
//           <div className="border-b border-[#0000001A] pb-3 flex">
//             <span className="text-[14px] text-[#00000080] font-medium w-[75%]">Document Name</span>
//             <span className="text-[14px] text-[#00000080] font-medium w-[25%]">Tags</span>
//           </div>
//         </div>

//         {/* --- File List --- */}
//         <div className="flex-1 overflow-y-auto px-4 custom-scrollbar">
//           {loading ? (
//             <div className="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
//               <Loader2 className="w-8 h-8 animate-spin text-[#C95EBE]" />
//               <span className="text-sm">Loading files...</span>
//             </div>
//           ) : filteredFiles.length > 0 ? (
//             <div className="py-2 space-y-2">
//               {filteredFiles.map((file) => {
//                 const isSelected = selectedFileId === file.id;
//                 return (
//                   <div
//                     key={file.id}
//                     onClick={() => {
//                         if (importStatus === 'idle') {
//                             setSelectedFileId(isSelected ? null : file.id);
//                         }
//                     }}
//                     className={`relative flex items-center px-2 py-2 rounded-lg cursor-pointer transition-all border ${
//                       isSelected
//                         ? "bg-[#fdf2f8] border-[#f0abfc] shadow-sm"
//                         : "bg-white border-transparent hover:bg-gray-50"
//                     } ${importStatus !== 'idle' ? 'cursor-not-allowed opacity-70' : ''}`}
//                   >
//                     {/* Document Name & Icon */}
//                     <div className="w-[75%] pl-3 flex items-center gap-3 pr-4">
//                       <div className="shrink-0">
//                         {getFileIcon(file.name, file.file_type)}
//                       </div>
//                       <span className="text-[14px] text-gray-700 font-medium truncate">
//                         {file.name}
//                       </span>
//                     </div>

//                     {/* Tag & Checkmark */}
//                     <div className="w-[25%] flex items-center justify-between">
//                       <span 
//                         className={`p-4 py-1 rounded-full text-[12px] font-medium border ${getTagStyle(file.type)}`}
//                       >
//                         {file.type || "RFP"}
//                       </span>
                      
//                       {/* Only show Green Check when selected */}
//                       {isSelected && (
//                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                         <path d="M8.6 11.8L6.45 9.65C6.26667 9.46667 6.03333 9.375 5.75 9.375C5.46667 9.375 5.23333 9.46667 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.1 14.1 8.33333 14.2 8.6 14.2C8.86667 14.2 9.1 14.1 9.3 13.9L14.95 8.25C15.1333 8.06667 15.225 7.83333 15.225 7.55C15.225 7.26667 15.1333 7.03333 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" fill="#34C759"/>
//                       </svg>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           ) : (
//             <div className="h-full flex items-center justify-center text-gray-400 text-sm">
//               No documents found
//             </div>
//           )}
//         </div>

//         {/* --- Footer --- */}
//         <div className="py-5 flex justify-center">
//           <button
//             disabled={!selectedFileId || importStatus !== 'idle'}
//             onClick={handleImportClick}
//             className={`flex items-center gap-2 px-6 py-2 rounded-lg text-[14px] font-medium transition-all shadow-sm ${
//               selectedFileId
//                 ? importStatus === 'success' 
//                     ? "bg-green-600 text-white border border-green-600"
//                     : "bg-[#C95EBE] text-white border border-[#C95EBE]"
//                 : "bg-gray-100 text-gray-400 cursor-not-allowed"
//             }`}
//           >
//             {/* Conditional Rendering of Button Content */}
//             {importStatus === 'loading' ? (
//                 <>
//                     <Loader2 size={16} className="animate-spin" />
//                     Processing...
//                 </>
//             ) : importStatus === 'success' ? (
//                 <>
//                     <CheckCircle2 size={16} />
//                     Extracted
//                 </>
//             ) : (
//                 <>
//                     <Upload size={16} />
//                     Import and Extract
//                 </>
//             )}
//           </button>
//         </div>

//       </div>
      
//       {/* Click outside to close (disabled while processing) */}
//       <div 
//         className="absolute inset-0 -z-10" 
//         onClick={() => { if(importStatus === 'idle') onClose(); }}
//       ></div>
//     </div>
//   );
// };

// export default SelectProjectModal;
import React, { useState, useEffect, useCallback } from "react";
import Cookies from "js-cookie";
import {
  Search, 
  Loader2, 
  Upload,
  CheckCircle2 
} from "lucide-react";
import api from "../../../chat/api";
import toast from "react-hot-toast";
import { isPlanLimitError } from "../../../../events/planLimitEvents";

const SelectProjectModal = ({ isOpen, onClose, folderId, onImport }) => {
  const [loading, setLoading] = useState(false);
  const [filesData, setFilesData] = useState({ documents: [], folder_name: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFileId, setSelectedFileId] = useState(null);
  
  // New state for handling the import button process
  // 'idle' | 'loading' | 'success'
  const [importStatus, setImportStatus] = useState('idle');

  // --- API Logic for Fetching Files ---
  const fetchFiles = useCallback(async () => {
    if (!folderId) return;

    setLoading(true);
    try {
      const orgId = Cookies.get("selected_org_id");
      const filesUrl = orgId
        ? `api/v1/rfp/folders/${folderId}/files/?organization_id=${encodeURIComponent(orgId)}`
        : `api/v1/rfp/folders/${folderId}/files/`;
      const response = await api.get(filesUrl);

      if (response.status === 200) {
        const data = response.data;
        
        const mappedFiles = {
          msg: data.msg || "Documents retrieved successfully",
          documents: data.documents?.map((doc) => ({
              id: doc.id,
              name: doc.name || "Untitled",
              uploaded_at: doc.uploaded_at,
              size: doc.size || "0 KB",
              type: doc.type || "-", // Used for Tag
              url: doc.url,
              key: doc.key,
              file_type: doc.file_type || doc.name?.split('.').pop(), // Used for Icon
              time_ago: doc.time_ago,
              status: doc.status || "ready",
            })) || [],
          folder_name: data.folder_name,
        };

        setFilesData(mappedFiles);
      } else {
        setFilesData({ documents: [], folder_name: "N/A" });
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      const status = error.response?.status;
      const apiError = error.response?.data?.error;
      if ((status === 400 || status === 403) && apiError) {
        toast.error(apiError);
      } else {
        toast.error("Failed to load project files");
      }
      setFilesData({ documents: [], folder_name: "N/A" });
    } finally {
      setLoading(false);
    }
  }, [folderId]);

  useEffect(() => {
    if (isOpen) {
      fetchFiles();
      setSelectedFileId(null); 
      setSearchQuery("");
      setImportStatus('idle'); // Reset button state on open
    }
  }, [isOpen, fetchFiles]);

  // --- Handle Import & Extract Button Click ---
  const handleImportClick = async () => {
    if (!selectedFileId) return;

    // 1. Show Loading "Processing..."
    setImportStatus('loading');

    try {
        const payload = {
            folder_id: folderId,
            doc_id: selectedFileId
        };

        // 2. Make API Call
        const response = await api.post("/api/v1/rfp/import-questionnaire/", payload);

        if (response.status === 200 || response.status === 201) {
            // 3. Show Success "Extracted"
            setImportStatus('success');
            toast.success("Import started successfully!");

            // 4. Wait 2 seconds, then Close & Refresh
            setTimeout(() => {
                onImport(); // Trigger parent refresh
                onClose();  // Close modal
                setImportStatus('idle'); // Reset for next time
            }, 2000);
        } else {
            throw new Error("API responded with non-success status");
        }

    } catch (error) {
        console.error("Import failed:", error);
        if (!isPlanLimitError(error)) toast.error("Failed to import questionnaire.");
        setImportStatus('idle'); // Revert button on error
    }
  };

  // --- Filtering ---
  const filteredFiles = filesData.documents.filter((doc) =>
    doc.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // --- Helper: File Icons (Updated) ---
  const getFileIcon = (fileType) => {
    const type = fileType?.toLowerCase();
    return (
      <img
        src={
          type === "pdf"
            ? "/pdff.svg"
            : type === "xlsx" || type === "xls"
            ? "/Xls.svg"
            : type === "docx"
            ? "/docX.svg"
            : type === "csv"
            ? "/CSV.svg"
            : "/TXT.svg"
        }
        className="w-5 h-5 flex-shrink-0"
        alt={`${type} icon`}
      />
    );
  };

  // --- Helper: Tags ---
  const getTagStyle = (tag) => {
    const t = (tag || "").toLowerCase();
    if (t === "urgent") return "bg-purple-100 text-purple-700 border-purple-300";
    if (t === "budget") return "bg-[#ecfccb] text-[#4d7c0f] border-[#d9f99d]";
    if (t === "questionnaire") return "bg-red-100 text-red-700 border-red-200";
    if (t === "t&c") return "bg-yellow-100 text-yellow-700 border-yellow-200";
    if (t === "sales") return "bg-pink-100 text-pink-700 border-pink-200";
    if (t === "rfp") return "bg-green-100 text-green-700 border-green-200";
    return "bg-gray-100 text-gray-600 border-gray-200";
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[1px] animate-in fade-in duration-200">
      
      <div 
        className="bg-white rounded-xl shadow-2xl w-full font-outfit max-w-[650px] flex flex-col animate-in zoom-in-95 duration-200 border border-gray-100"
        style={{ height: '600px', maxHeight: '70vh' }}
      >
        
        {/* --- Header --- */}
        <div className="px-8 pt-6 pb-2">
          <div className="flex justify-between items-start mb-1">
            <div>
              <h2 className="text-[18px] font-semibold text-[#18101C] leading-tight">
                {filesData.folder_name || "Project Files"}
              </h2>
              <p className="text-[14px] text-[#52525B] font-normal mt-1">
                Select a file ({selectedFileId ? "1" : "0"}/1 Selected)
              </p>
            </div>

            <div className="relative w-[240px]">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search documents"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-9 pr-3 py-2 bg-white border border-gray-200 rounded-md !text-[14px] !leading-5 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors"
              />
            </div>
          </div>
        </div>

        {/* --- Column Headers --- */}
        <div className="px-8 mt-2">
          <div className="border-b border-[#0000001A] pb-3 flex">
            <span className="text-[14px] text-[#00000080] font-medium w-[75%]">Document Name</span>
            <span className="text-[14px] text-[#00000080] font-medium w-[25%]">Tags</span>
          </div>
        </div>

        {/* --- File List --- */}
        <div className="flex-1 overflow-y-auto px-4 custom-scrollbar">
          {loading ? (
            <div className="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
              <Loader2 className="w-8 h-8 animate-spin text-[#C95EBE]" />
              <span className="text-sm">Loading files...</span>
            </div>
          ) : filteredFiles.length > 0 ? (
            <div className="py-2 space-y-2">
              {filteredFiles.map((file) => {
                const isSelected = selectedFileId === file.id;
                return (
                  <div
                    key={file.id}
                    onClick={() => {
                        if (importStatus === 'idle') {
                            setSelectedFileId(isSelected ? null : file.id);
                        }
                    }}
                    className={`relative flex items-center px-2 py-2 rounded-lg cursor-pointer transition-all border ${
                      isSelected
                        ? "bg-[#fdf2f8] border-[#f0abfc] shadow-sm"
                        : "bg-white border-transparent hover:bg-gray-50"
                    } ${importStatus !== 'idle' ? 'cursor-not-allowed opacity-70' : ''}`}
                  >
                    {/* Document Name & Icon */}
                    <div className="w-[75%] pl-3 flex items-center gap-3 pr-4">
                      <div className="shrink-0">
                        {getFileIcon(file.file_type)}
                      </div>
                      <span className="text-[14px] text-gray-700 font-medium truncate">
                        {file.name}
                      </span>
                    </div>

                    {/* Tag & Checkmark */}
                    <div className="w-[25%] flex items-center justify-between">
                      <span 
                        className={`p-4 py-1 rounded-full text-[12px] font-medium border ${getTagStyle(file.type)}`}
                      >
                        {file.type || "RFP"}
                      </span>
                      
                      {/* Only show Green Check when selected */}
                      {isSelected && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M8.6 11.8L6.45 9.65C6.26667 9.46667 6.03333 9.375 5.75 9.375C5.46667 9.375 5.23333 9.46667 5.05 9.65C4.86667 9.83333 4.775 10.0667 4.775 10.35C4.775 10.6333 4.86667 10.8667 5.05 11.05L7.9 13.9C8.1 14.1 8.33333 14.2 8.6 14.2C8.86667 14.2 9.1 14.1 9.3 13.9L14.95 8.25C15.1333 8.06667 15.225 7.83333 15.225 7.55C15.225 7.26667 15.1333 7.03333 14.95 6.85C14.7667 6.66667 14.5333 6.575 14.25 6.575C13.9667 6.575 13.7333 6.66667 13.55 6.85L8.6 11.8ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z" fill="#34C759"/>
                      </svg>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="h-full flex items-center justify-center text-gray-400 text-sm">
              No documents found
            </div>
          )}
        </div>

        {/* --- Footer --- */}
        <div className="py-5 flex justify-center">
          <button
            disabled={!selectedFileId || importStatus !== 'idle'}
            onClick={handleImportClick}
            className={`flex items-center gap-2 px-6 py-2 rounded-lg text-[14px] font-medium transition-all shadow-sm ${
              selectedFileId
                ? importStatus === 'success' 
                    ? "bg-green-600 text-white border border-green-600"
                    : "bg-[#C95EBE] text-white border border-[#C95EBE]"
                : "bg-gray-100 text-gray-400 cursor-not-allowed"
            }`}
          >
            {/* Conditional Rendering of Button Content */}
            {importStatus === 'loading' ? (
                <>
                    <Loader2 size={16} className="animate-spin" />
                    Processing...
                </>
            ) : importStatus === 'success' ? (
                <>
                    <CheckCircle2 size={16} />
                    Extracted
                </>
            ) : (
                <>
                    <Upload size={16} />
                    Import and Extract
                </>
            )}
          </button>
        </div>

      </div>
      
      {/* Click outside to close (disabled while processing) */}
      <div 
        className="absolute inset-0 -z-10" 
        onClick={() => { if(importStatus === 'idle') onClose(); }}
      ></div>
    </div>
  );
};

export default SelectProjectModal;
